module.exports = __webpack_public_path__ + "static/media/alto.340dae26.jpg";